/* Keep the complete desktop media column together, including review and selling points. */
if (!customElements.get('thxsilk-sticky-media')) {
  customElements.define('thxsilk-sticky-media', class extends HTMLElement {
    connectedCallback() {
      this.desktop = window.matchMedia('(min-width: 990px)');
      this.header = document.querySelector('sticky-header');
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          if (!this.isConnected) return;
          if (!this.desktop.matches) {
            this.style.removeProperty('--thx-sticky-media-height');
            this.style.removeProperty('--thx-sticky-header-height');
            return;
          }
          this.style.setProperty('--thx-sticky-media-height', `${Math.ceil(this.offsetHeight)}px`);
          this.style.setProperty('--thx-sticky-header-height', `${this.header ? Math.ceil(this.header.offsetHeight) : 0}px`);
        });
      };
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(this.schedule);
        this.observer.observe(this);
        if (this.header) this.observer.observe(this.header);
      }
      window.addEventListener('resize', this.schedule, { passive: true });
      this.desktop.addEventListener('change', this.schedule);
      this.schedule();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      window.removeEventListener('resize', this.schedule);
      this.desktop?.removeEventListener('change', this.schedule);
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = null;
    }
  });
}
